import React from 'react'
import { Link } from 'react-router-dom';

function United() {
    const images = [
        {
          src: "images/daisypre.jpg",
          title: "Modern Design",
          description: "Available in 91 or 100 cm wide and 120 or 135 cm high models.",
        },
        {
          src: "images/daisypre1.jpg",
          title: "Refrigerated Storage",
          description: "Models with refrigerated understorage and independent temperature control for quick product replenishment.",
        },
        {
          src: "images/daisypre2.jpg",
          title: "Easy Access",
          description: "Front glass with gas strut for easy access and cleaning of the display unit.",
        },
      ];
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/Multideck" className="block py-1 pl-4 hover:underline mt-6">Multideck -</Link>
           <span className="block py-1 pl-4 mt-6">United</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/unitednn.png" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">United</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Fresh foodstuffs in plain view, do more for your business!</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">DSGO plug-in multidecks offer 5 display levels, panoramic end walls, LED lighting, both superior and lateral. Designed for cold and hot food: Charcuterie Products, Drinks, Sandwiches, Salads, Cheese, Yogurts, Sushi, Take-Away, Fresh Produce, Dry Salted Fish, ..., the range is available in two models, with 62 cm and 80 cm width, to maximize every inch of your business!</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">Charcuterie, Dairy products and Beverages <span className=' text-blue-400'>-1… +5 °C</span> (3M1)<span className=' text-blue-400'> -1… +7 °C</span>   (3M2)</p>

       <p className="text-xl lg:text-2xl opacity-90">Fresh Produce<span className=' text-blue-400'>-1… +10 °C</span> (3H1)</p>
       <p className="text-xl lg:text-2xl opacity-90">Salted Fish<span className=' text-blue-400'> -1… +5 °C</span>(3M1)</p>
       <p className="text-xl lg:text-2xl opacity-90">Hot food<span className=' text-red-600'> +65 °C</span> </p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
         
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">R290</p>

         </div>
    
   


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Food products always fresh and well visible!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>UNITED multidecks are great for promoting and selling your packaged food products. The efficient ventilated refrigeration system with optimized air curtain ensures an even temperature through the unit. Also, 5 high capacity display levels can hold a lot of food and are easy to restock.</div>

    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>High performance, low energy consumption, visibility and low noise for the best shopping experience.</div>

</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/unitedcase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/unitedcase2.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Soups, noodles, sandwiches, … all warm and handy!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>UNITED heated merchandisers keep hot food at the right temperature for an extended time without losing its organoleptic qualities. The new ventilated heating system distributes the temperature evenly across all display levels, preventing food spoilage. Thanks to its high energy efficiency, it also reduces operating costs.</div>
</div>
             </div>

             

         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center">
  {[
    {
      img: "images/unitedcard.jpg",
      text: "Available in two widths, 62 and 80-cm, to adapt to different shop spaces.",
    },
    {
      img: "images/unitedcard1.jpg",
      text: "Double-glazed front doors for up to 50% on energy savings (optional).",
    },
    {
      img: "images/unitedcard2.jpg",
      text: "Canopy and vertical high-brightness and energy-efficient LED lighting for maximum visibility of your products.",
    },
    {
      img: "images/unitedcard3.jpg",
      text: "Easy access to the condenser unit for cleaning and maintenance.",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


 {/* case 3 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                  {/* ✅ Image Wrapper */}
  <div className="w-full md:w-1/2">
                 <img src="/images/unitedcase3.gif" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Pass-through model for quicker product re-stock!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>UNITED refrigerated multidecks are also available with service doors that facilitate the operations in store, so that you never lack product to your customers.</div>
</div>

             </div>

             {/* case 4 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
   
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Choose your style!
    Different finishing's and accessories.</p>
    <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl font-thin opacity-90 mt-6">
  Available as stainless steel or white model.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Panoramic end panel with double glazing unit or mirrored end panel.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Wide range of accessories to maximize sales.
  </li>
</ul>
</div>
               {/* ✅ Image Wrapper */}
               <div className="w-full md:w-1/2">
                 <img src="/images/unitedcase6.png" className="max-w-full h-auto object-contain" />
               </div>
             </div>

             {/* case 5 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                  {/* ✅ Image Wrapper */}
  <div className="w-full md:w-1/2">
                 <img src="/images/unitedcase4.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Manual or electric lockable roller shutter for additional protection for your goods.</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Models available with manual or electric lockable roller shutter for additional security of your products and saving energy. </div>
</div>

             </div>

                        {/* case 6 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >

               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">A multideck range with more options for your business.</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Specific model without base to be placed on counter top or to be built-in, always for remote condensing unit installation.</div>
</div>
                  {/* ✅ Image Wrapper */}
                  <div className="w-full md:w-1/2">
                 <img src="/images/unitedcase5.png" className="max-w-full h-auto object-contain" />
               </div>
             </div>
     </div>
    
  
        </div>
      )
    }


export default United